﻿import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

export default class Loader extends React.Component {
    static get propTypes() {
        return {
            color: PropTypes.string,
            margin: PropTypes.string
        };
    }

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Wrapper>
                <Spinner margin={this.props.margin}>
                    <Bouncer color={this.props.color} />
                    <Bouncer2 color={this.props.color} />
                </Spinner>
            </Wrapper>
        );
    }        
}

const Wrapper = styled.div`
    position: relative;
    display: block;
    margin: 0 auto;


    &::before {
        content: " ";
        display: table;
    }
      
    &::after {
        content: " ";
        display: table;
        clear: both;
    }
`;

const Spinner = styled.div`
    width: 40px;
    height: 40px;

    position: relative;
    margin: ${props => props.margin ? props.margin : '100px auto'};
`;

const BounceAnimation = keyframes`
    0%, 100% { 
        transform: scale(0.0);
    } 50% { 
        transform: scale(1.0);
    }
`;

const Bouncer = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50%;
    background-color: ${props => props.color ? props.color : '#333'}; 
    opacity: 0.6;
    animation: ${BounceAnimation} 2.0s infinite ease-in-out;
`;

const Bouncer2 = styled(Bouncer)`
    animation-delay: -1.0s;
`;